var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7512 1.00415C11.4922 0.262033 12.694 0.261578 13.4356 1.00314L15.8015 3.36901C16.5367 4.10425 16.5443 5.29451 15.8186 6.03913L14.1567 7.74422L9.08516 2.67268L10.7512 1.00415ZM8.07889 3.68048L13.1626 8.76418L7.05224 15.0334C6.51636 15.5833 5.78137 15.8933 5.01389 15.8933L2.40088 15.8931C1.59117 15.8931 0.944528 15.2181 0.978581 14.4085L1.09076 11.7415C1.12076 11.0283 1.4172 10.3523 1.92142 9.84728L8.07889 3.68048ZM9.89845 15.1705C9.89845 15.564 10.2179 15.8827 10.6111 15.8827H16.2222C16.6154 15.8827 16.9339 15.564 16.9339 15.1705C16.9339 14.7771 16.6154 14.4584 16.2222 14.4584H10.6111C10.2179 14.4584 9.89845 14.7771 9.89845 15.1705Z",
    fill: "#1F2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2aa9b34c49928e349c6ecc2a29eac6b6.svg";
export { ForwardRef as ReactComponent };